let preloader = document.querySelector('.preloader__wrapper');

window.addEventListener('load', () => {
  preloader.classList.add('hide');
  const animItems = document.querySelectorAll(`.anim__item`)
  if (animItems.length > 0) {
      window.addEventListener(`scroll`, animOnScroll)

      function animOnScroll() {
          for (let index = 0; index < animItems.length; index++) {
              const animItem = animItems[index]
              const animItemHeight = animItem.offsetHeight
              const animItemOffSet = offset(animItem).top
              const animStart = 4
              let animItemPoint = window.innerHeight - animItemHeight / animStart
              if (animItemHeight > window.innerHeight) {
                  animItemPoint = window.innerHeight - window.innerHeight / animStart
              }
              if ((pageYOffset > animItemOffSet - animItemPoint) && pageYOffset < (animItemOffSet + animItemHeight)) {
                  animItem.classList.add(`anim__active`)
              } else {
                  if (!(animItem.classList.contains(`anim__no__hide`))) {
                      animItem.classList.remove(`anim__active`)
                  }
              }
          }
      }

      function offset(el) {
          const rect = el.getBoundingClientRect()
          let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop
          return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
      }

      animOnScroll();

      /* setTimeout(() => {
          animOnScroll()
      }, 300) */
  }
})

import './components/menu.js'
import './components/services.js'
import './components/portfolio.js'
import './components/modal.js'